import CircleIcon from '@mui/icons-material/Circle';
import { useTheme } from '@mui/material';
import { FeatureEnum } from '../../services/data/impl/cube/cubeSlice';
import { useTranslation } from '../../services/translation/hooks/useTranslation';
import SVGViewer from './SVGViewer';
import blueberryIcon from './icons/blueberry.svg';
import flowersAndBlueberriesIcon from './icons/flower-and-blueberry.svg';
import flowerClosedIcon from './icons/flower-closed.svg';
import flowerOpenIcon from './icons/flower-open.svg';
import flowerPetalFallIcon from './icons/flower-petalfall.svg';
import flowerIcon from './icons/flower.svg';
const SvgIcon = (icon: string, alt: string, size: number) => {
  return <SVGViewer svg={icon} alt={alt} pxSize={size} />;
};

const DotIcon = (color: string, alt: string, size: number) => {
  return (
    <CircleIcon
      aria-label={alt}
      sx={{ height: size + 'px', width: size + 'px', color: color }}
    />
  );
};

export const useBlueberryFeatureIcon = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (feature: FeatureEnum | null, scale = 1) => {
    switch (feature) {
      case FeatureEnum.blueberry:
        return SvgIcon(blueberryIcon, t(FeatureEnum.blueberry), 45 * scale);
      case FeatureEnum.flower:
        return SvgIcon(flowerIcon, t(FeatureEnum.flower), 40 * scale);
      case FeatureEnum.blueberry_Blue:
        return DotIcon(
          theme.colors.blueberryColors.blue,
          t(FeatureEnum.blueberry_Blue),
          20 * scale
        );
      case FeatureEnum.blueberry_Purple:
        return DotIcon(
          theme.colors.blueberryColors.purple,
          t(FeatureEnum.blueberry_Purple),
          20 * scale
        );
      case FeatureEnum.blueberry_Yellow:
        return DotIcon(
          theme.colors.blueberryColors.pink,
          t(FeatureEnum.blueberry_Yellow),
          20 * scale
        );
      case FeatureEnum.blueberry_Green:
        return DotIcon(
          theme.colors.blueberryColors.green,
          t(FeatureEnum.blueberry_Green),
          20 * scale
        );
      case FeatureEnum.flower_closed:
        return SvgIcon(
          flowerClosedIcon,
          t(FeatureEnum.flower_closed),
          18 * scale
        );
      case FeatureEnum.flower_open:
        return SvgIcon(flowerOpenIcon, t(FeatureEnum.flower_open), 18 * scale);
      case FeatureEnum.flower_petalfall:
        return SvgIcon(
          flowerPetalFallIcon,
          t(FeatureEnum.flower_petalfall),
          18 * scale
        );
      default:
        return SvgIcon(
          flowersAndBlueberriesIcon,
          t('Flowers and Berries'),
          45 * scale
        );
    }
  };
};
